import React, { Component } from 'react'
import AuthForm from './AuthForm'
import User from './User'

class Auth extends Component {
  componentWillMount() {
    const { history } = this.props
    this.props.willMount(history)
  }

  render() {
    const { token, auth, signOut, history, signIn } = this.props
    return (
      <div>
        {token ? (
          <User auth={auth} signOut={() => signOut(history)} history={history} />
        ) : (
          <AuthForm
            onSubmit={values => signIn(values, history)}
            history={history}
            isAuthCard={this.props.isAuthCard}
            setIsAuthCard={this.props.setIsAuthCard}
          />
        )}
      </div>
    )
  }
}

export default Auth
